import { Globalize } from '@grapecity/wijmo'

export const CURRENCY_MILLIONS_FORMAT = 'c1m'

export function formatQuarterlyMeasurableValue(
    format: string | null | undefined,
    value: number | null | undefined,
    empty = '',
): string {
    if (value == null) {
        return empty
    }

    const fmt = format || 'n2'
    if (fmt.toLowerCase() === CURRENCY_MILLIONS_FORMAT) {
        const millions = value / 1_000_000
        const abs = Globalize.format(Math.abs(millions), 'n1')
        return `${millions < 0 ? '-' : ''}$${abs}M`
    }

    try {
        return Globalize.format(value, fmt)
    } catch {
        return String(value)
    }
}

export function formatQuarterlyMeasurableExact(value: number | null | undefined): string {
    if (value == null) {
        return ''
    }
    try {
        return Globalize.format(value, 'c0')
    } catch {
        return String(value)
    }
}
